// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__4U+Qr","searchInput":"SearchBar_searchInput__yxHKM"};